export default "__VITE_ASSET__D33V9t4a__"